import { EntityAccountType } from 'src/models';
import * as Yup from 'yup';

export const getEntityAccountApplicationValidationSchema = (entityAccountType?: EntityAccountType) => {
  if (entityAccountType?.isCorporate) {
    return Yup.object().shape({
      Application: Yup.string().required(
        'Completed Corporate Account Application must be Uploaded to establish an account.',
      ),
      ArticlesOfIncorporation: Yup.string().required(
        'Copy of Certified Articles of Incorporation must be Uploaded to process your application.',
      ),
      GovernmentId: Yup.string().required('Copy of government issued ID must be Uploaded to process your application.'),
    });
  }

  if (entityAccountType?.isLlc) {
    return Yup.object().shape({
      Application: Yup.string().required(
        'Completed LLC Corporate Account Application must be Uploaded to establish an account.',
      ),
      OperatingAgreement: Yup.string().required(
        'Copy of Operating Agreement must be Uploaded to process your application.',
      ),
      ArticlesOfOrganization: Yup.string().required(
        'Copy of Certified Articles of Organization must be Uploaded to process your application.',
      ),
      GovernmentId: Yup.string().required('Copy of government issued ID must be Uploaded to process your application.'),
    });
  }

  if (entityAccountType?.isPartnership) {
    return Yup.object().shape({
      Application: Yup.string().required(
        'Completed Partnership Account Application must be Uploaded to establish an account.',
      ),
      PartnershipAgreement: Yup.string().required(
        'Copy of Partnership Agreement must be Uploaded to process your application.',
      ),
      GovernmentId: Yup.string().required('Copy of government issued ID must be Uploaded to process your application.'),
    });
  }

  if (entityAccountType?.isTrust) {
    return Yup.object().shape({
      Application: Yup.string().required(
        `Completed ${
          entityAccountType.isPersonalTrust ? 'Personal' : 'Business'
        } Trust Application must be Uploaded to establish an account.`,
      ),
      TrustAgreement: Yup.string().required('Copy of Trust Agreement must be Uploaded to process your application.'),
      GovernmentId: Yup.string().required('Copy of government issued ID must be Uploaded to process your application.'),
    });
  }
};
